// libraries
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { Doughnut } from "react-chartjs-2";
// redux
import { connect } from "react-redux";
// utils functions
import { computeTotalEnergy } from "../Utility/utilsFunctions";
// styles
import { lkGreen, lkRed } from "../Utility/styleComponents";
import { loadChargersWithStatus } from "../../api/utils/loadChargerStatus";
import useIsMounted from "../Utility/useIsMounted";

const ActiveKnob = (props) => {
  const { chargerIds, energyConsumed, dbFilter } = props;
  const { dateRange, location } = dbFilter;
  const [series, setSeries] = useState();
  const [chargerData, setChargerData] = useState([]);
  const isMounted = useIsMounted();
  // console.log("series active knob: ",series);

  const data = {
    labels: ["Idle", "Active"],
    datasets: [
      {
        data: series,
        backgroundColor: [lkRed, lkGreen],
        borderWidth: 0,
      },
    ],
  };

  // Chart options
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: false,
      },
    },
  };

  const [totalEnergy, setTotalEnergy] = useState(0);

  // console.log("EnergyConsumed: ", energyConsumed);
  // console.log("totalEnergy: ", totalEnergy);
  useEffect(() => {
    handleGetChargerData();
  }, [chargerIds]);

  // to get all the chargers data, to cal the rating
  const handleGetChargerData = async () => {
    try {
      // setLoadingChargers(true);
      const { formatData, status } = await loadChargersWithStatus(chargerIds, {});
      console.log("formatData chargers data: ", formatData);

      if (formatData?.length > 0) {
        isMounted.current && setChargerData(formatData);
      }
      // setLoadingChargers(false);
    } catch (err) {
      console.log("Err fetching the chargers data: ");
    }
  };
  useEffect(() => {
    getEnergyUtilization();
  }, [dateRange, chargerData, energyConsumed]);

  const getEnergyUtilization = async () => {
    const totalPower = chargerData.reduce((sum, { rating }) => {
      if (typeof rating === "string") {
        const numericValue = parseFloat(rating.replace("k", "")) || 0;

        return sum + numericValue;
      }
      return sum;
    }, 0);

    const currentDateRange = dateRange;

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(currentDateRange[0]);
    const secondDate = new Date(currentDateRange[1]);

    const numberOfDays = Math.round(Math.abs((firstDate - secondDate) / oneDay)) + 1;

    const numberOfHrs = 16;
    const totalEnergy = computeTotalEnergy(totalPower, numberOfDays, numberOfHrs);

    setTotalEnergy(totalEnergy);

    const totalUtilization = ((energyConsumed / totalEnergy) * 100).toFixed(2);
    const remaining = (100 - totalUtilization).toFixed(2);

    isMounted.current && setSeries([Number(remaining), Number(totalUtilization)]);
  };

  return (
    <React.Fragment>
      <Card className="mb-8" style={{ height: "450px" }}>
        <CardBody>
          <div className="float-right">
            {false && (
              <select className="custom-select custom-select-sm">
                <option value="1">Jan</option>
                <option defaultValue>Feb</option>
                <option value="2">Mar</option>
                <option value="3">Apr</option>
                <option value="4">May</option>
                <option value="5">Jun</option>
                <option value="6">Jul</option>
                <option value="7">Aug</option>
                <option value="8">Sep</option>
                <option value="9">Oct</option>
                <option value="10">Nov</option>
                <option value="11">Dec</option>
              </select>
            )}
          </div>
          <CardTitle className="mb-8">Utilization rate</CardTitle>

          <div id="donut-chart" className="apex-charts mt-8 d-flex justify-content-center align-items-center pt-20">
            <div
              style={{
                width: "690px",
                height: "370px",
                position: "relative",
              }}
            >
              {/* Donut Chart */}
              {series && series?.length > 0 && (
                <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                  <Doughnut data={data} options={options} />
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    <div className="d-flex justify-content-center align-items-center">
                      <div
                        className="d-inline-block me-2 rounded-circle"
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: lkRed,
                        }}
                      />
                      Idle: {Number(series[0])}%
                    </div>
                    <div className="d-flex justify-content-center align-items-center pl-4">
                      <div
                        className="d-inline-block me-2 rounded-circle"
                        style={{
                          width: "12px",
                          height: "12px",
                          backgroundColor: lkGreen,
                        }}
                      />
                      Active: {Number(series[1])}%
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  chargerIds: state.ChargerManagement.chargerIds,
});

export default connect(mapStateToProps)(ActiveKnob);
